import { Mail, Phone, Instagram, MapPin, MessageCircle } from "lucide-react";
import { CONTACT } from "@/data/site";
import { Reveal, Eyebrow } from "./Reveal";
import { EnquiryForm } from "./EnquiryForm";

const ITEMS = [
  { icon: Mail, label: "Email", value: CONTACT.email, href: `mailto:${CONTACT.email}`, id: "email" },
  { icon: Phone, label: "Phone", value: CONTACT.phoneDisplay, href: `tel:${CONTACT.phone}`, id: "phone" },
  { icon: MessageCircle, label: "WhatsApp", value: "Chat with us", href: CONTACT.whatsapp, id: "whatsapp" },
  { icon: Instagram, label: "Instagram", value: CONTACT.instagramHandle, href: CONTACT.instagram, id: "instagram" },
  { icon: MapPin, label: "Studio · Google", value: CONTACT.address, href: CONTACT.google, id: "map" },
];

export const Contact = () => (
  <section id="contact" className="max-w-7xl mx-auto px-6 lg:px-10 py-24 lg:py-36" data-testid="contact-section">
    <div className="grid lg:grid-cols-12 gap-14 lg:gap-20">
      <Reveal className="lg:col-span-5">
        <Eyebrow className="mb-6">06 / Contact</Eyebrow>
        <h2 className="font-serif font-light text-4xl sm:text-5xl tracking-tight text-stone-900 leading-tight">Let's shape your <em className="text-[#B85C38]">space</em>.</h2>
        <p className="mt-6 text-stone-600 font-light leading-relaxed max-w-sm">Share a few details about your project and we'll get back to you to arrange a conversation.</p>
        <ul className="mt-12 space-y-6">
          {ITEMS.map(({ icon: Icon, label, value, href, id }) => (
            <li key={id}>
              <a href={href} target={href.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer" className="group flex gap-4 items-start" data-testid={`contact-${id}-link`}>
                <Icon size={18} className="mt-1 text-stone-500 group-hover:text-[#B85C38] transition-colors" />
                <span>
                  <span className="block font-mono text-[11px] uppercase tracking-[0.2em] text-stone-500">{label}</span>
                  <span className="link-line text-stone-900">{value}</span>
                </span>
              </a>
            </li>
          ))}
        </ul>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-7 bg-white border border-stone-200 p-8 sm:p-12">
        <EnquiryForm />
      </Reveal>
    </div>
  </section>
);
